__turbopack_context__.v({
  "advancedSidebarModal": "sidebar-module-sass-module__aa2TPW__advancedSidebarModal",
  "selected": "sidebar-module-sass-module__aa2TPW__selected" + " " + __turbopack_context__.i(267166)["selected"],
});
